export default __webpack_public_path__ + "static/media/Ballroll_00331.1be0ab1b.png";